import CommonConstants from '../constants/CommonConstants';
// import Immutable from 'immutable';

const initialState = {
	deliveriesList: [],
	error: null
};

function DeliveriesReducer(state = initialState, action) {
	switch (action.type) {
		case CommonConstants.GET_DELIVERIES_LIST_SUCCESS:
			return Object.assign({}, state, {
				deliveriesList: action.response,
				error: null
			});
			
		case CommonConstants.GET_DELIVERIES_LIST_ERROR:
			return Object.assign({}, state, {
				deliveriesList: {},
				error: action.error
			}); 

		default:
			return state;
	}
}

export default DeliveriesReducer;



// WEBPACK FOOTER //
// ./reducers/DeliveriesReducer.js